module.exports = __webpack_public_path__ + "static/media/gambler.73154168.jpg";